import React from "react";
import Skeleton from "@mui/material/Skeleton";

const LoadingMovieCard = () => {
  return <Skeleton variant="rectangular" width={266} height={400} />;
};

export default LoadingMovieCard;
